import { useState } from 'react';

import { Button } from '@packages/fenrir/components/button';
import { Typography } from '@packages/fenrir/components/typography';
import { styled } from '@packages/fenrir/styles';

import { useSecurityJourneyTranslations } from '../../../locales/use-security-journey-translations';

/* -------------------------------------------------------------------------------------------------
 * ListCell
 * -----------------------------------------------------------------------------------------------*/
const OrderedList = styled('ol')({
  listStyle: 'none',
  width: '100%',
  height: '100%',
  alignContent: 'center',
  paddingInline: 0,
  margin: 0,
});

type ListCellProps = {
  value: string[] | undefined;
};

export const ListCell = ({ value }: ListCellProps) => {
  /**
   * Get an instance of the translations
   */
  const { t } = useSecurityJourneyTranslations();

  const [expanded, setExpanded] = useState(false);

  if (value === undefined) return;

  const cellListValues = expanded ? value : value.slice(0, 3);

  return (
    <OrderedList>
      {cellListValues.map((item: string, index: number) => (
        <li key={index}>
          <Typography variant="body2" noWrap>
            {item}
          </Typography>
        </li>
      ))}
      {value.length > 3 && (
        <li>
          <Button
            sx={{
              padding: 0,
              display: 'inline-block',
            }}
            onClick={() => setExpanded(!expanded)}
          >
            {expanded
              ? t('common.blueprintsTable.listCell.viewLess')
              : t('common.blueprintsTable.listCell.viewMore', {
                  count: value.length - 3,
                })}
          </Button>
        </li>
      )}
    </OrderedList>
  );
};
